import type { ReactNode } from 'react';

export function DataPanel({
  loading,
  error,
  empty,
  children,
}: {
  loading: boolean;
  error: boolean;
  empty: boolean;
  children: ReactNode;
}) {
  if (loading) {
    return <section className="content-card data-state"><span className="inline-loader" /> Loading data…</section>;
  }
  if (error) {
    return <section className="content-card data-state error-state">Unable to load this data. Confirm that the API is running and try again.</section>;
  }
  if (empty) {
    return <section className="content-card data-state">No records are available in this workspace yet.</section>;
  }
  return children;
}

export function StatusPill({ value }: { value: string }) {
  return <span className={`status-pill status-${value}`}>{value.replaceAll('_', ' ')}</span>;
}
